module.exports = __webpack_public_path__ + "static/img/function-box-img1.63194c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fusionIntegration/function-box-img1.png
// module id = EQW2
// module chunks = 0